/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './verification_service';
import './kyb_model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbqualifier": {
        "nested": {
          "service": {
            "nested": {
              "GetKybDataRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "prepKybProcess": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "apiVersion": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "GetKybDataResponse": {
                "fields": {
                  "kybStatus": {
                    "type": "squareup.bbqualifier.service.VerificationStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "business": {
                    "type": "squareup.bbqualifier.service.KybBusiness",
                    "id": 2,
                    "rule": "optional"
                  },
                  "kybPersonas": {
                    "type": "squareup.bbqualifier.service.KybPersona",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "attestation": {
                    "type": "squareup.bbqualifier.service.KybAttestation",
                    "id": 4,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "GetKybVerificationDataRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "apiVersion": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetKybVerificationDataResponse": {
                "fields": {
                  "kybStatus": {
                    "type": "squareup.bbqualifier.service.VerificationStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "retryable": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "businessVerificationStatus": {
                    "type": "squareup.bbqualifier.service.VerificationStatus",
                    "id": 3,
                    "rule": "optional"
                  },
                  "accountOwnerRequired": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "accountOwnerSsnRequired": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "personaVerificationResults": {
                    "type": "squareup.bbqualifier.service.GetKybVerificationDataResponse.PersonaVerificationResult",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "isBusinessVerified": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "sspRequestToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "PersonaVerificationResult": {
                    "fields": {
                      "name": {
                        "type": "squareup.bbqualifier.service.KybPersonaName",
                        "id": 1,
                        "rule": "optional"
                      },
                      "verificationStatus": {
                        "type": "squareup.bbqualifier.service.VerificationStatus",
                        "id": 2,
                        "rule": "optional"
                      },
                      "legalEntityToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "ExternalVerificationDataService": {
                "methods": {
                  "GetKybData": {
                    "requestType": "squareup.bbqualifier.service.GetKybDataRequest",
                    "responseType": "squareup.bbqualifier.service.GetKybDataResponse"
                  },
                  "GetKybVerificationData": {
                    "requestType": "squareup.bbqualifier.service.GetKybVerificationDataRequest",
                    "responseType": "squareup.bbqualifier.service.GetKybVerificationDataResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.GetKybDataRequest && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.GetKybDataResponse && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.GetKybVerificationDataRequest && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.GetKybVerificationDataResponse && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.GetKybVerificationDataResponse?.nested?.PersonaVerificationResult && !$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.ExternalVerificationDataService) {
  $root.addJSON(jsonData);
}

/**
 * Use for obtaining the data to prefill KYB form
 *
 * SOURCE GetKybDataRequest @ squareup/bbqualifier/verification_data_service.proto at 27:1
 */
export const GetKybDataRequest = $root.lookupType('squareup.bbqualifier.service.GetKybDataRequest');
fixType(GetKybDataRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetKybDataRequest);
/**
 * SOURCE GetKybDataResponse @ squareup/bbqualifier/verification_data_service.proto at 36:1
 */
export const GetKybDataResponse = $root.lookupType('squareup.bbqualifier.service.GetKybDataResponse');
fixType(GetKybDataResponse);
Builder.createAndAttachToType(GetKybDataResponse);
/**
 * Use for obtaining verification result
 *
 * SOURCE GetKybVerificationDataRequest @ squareup/bbqualifier/verification_data_service.proto at 45:1
 */
export const GetKybVerificationDataRequest = $root.lookupType('squareup.bbqualifier.service.GetKybVerificationDataRequest');
fixType(GetKybVerificationDataRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetKybVerificationDataRequest);
/**
 * SOURCE GetKybVerificationDataResponse @ squareup/bbqualifier/verification_data_service.proto at 53:1
 */
export const GetKybVerificationDataResponse = $root.lookupType('squareup.bbqualifier.service.GetKybVerificationDataResponse');
fixType(GetKybVerificationDataResponse);
Builder.createAndAttachToType(GetKybVerificationDataResponse);
/**
 * SOURCE PersonaVerificationResult @ squareup/bbqualifier/verification_data_service.proto at 54:3
 */
GetKybVerificationDataResponse.PersonaVerificationResult = $root.lookupType('squareup.bbqualifier.service.GetKybVerificationDataResponse.PersonaVerificationResult');
fixType(GetKybVerificationDataResponse.PersonaVerificationResult);
Builder.createAndAttachToType(GetKybVerificationDataResponse.PersonaVerificationResult);
/**
 * SOURCE ExternalVerificationDataService @ squareup/bbqualifier/verification_data_service.proto at 99:1
 */
export const ExternalVerificationDataService = $root.lookupService('squareup.bbqualifier.service.ExternalVerificationDataService');